angular.module('zc')
  .component('zcIwSegmentRate', {
    templateUrl: '/templates/projects.iw/iw_segment_rate.html',
    bindings: {
      project: '<',
      filters: '<'
    },
    controller: zcIwSegmentRateController
  });

zcIwSegmentRateController.$inject = ['$scope', '$translate', 'InterestWidgetStats', 'ChartV2', 'pieChartV2Config', 'lib'];
function zcIwSegmentRateController($scope, $translate, InterestWidgetStats, ChartV2, pieChartV2Config, lib) {
  const vm = this;

  const chart = new ChartV2(pieChartV2Config);
  vm.chartConfig = chart.getConfig();

  vm.$onInit = () => {
    updateData();
    $scope.$on('filtersUpdated', updateData);
  };

  function updateData() {
    InterestWidgetStats.findByFilters(vm.project.apikey, vm.filters)
      .then(stats => {
        vm.total = InterestWidgetStats.transform(lib.sumCountMap(stats));
        let data = [];
        if(vm.total.iw_use.nocv_session_rate) {
          data.push([$translate.instant('projectsIw.segmentRate.nocvSessionRate'), vm.total.iw_use.nocv_session_rate]);
        }
        if(vm.total.iw_use.onecv_session_rate) {
          data.push([$translate.instant('projectsIw.segmentRate.onecvSessionRate'), vm.total.iw_use.onecv_session_rate]);
        }
        if(vm.total.iw_use.loyal_session_rate) {
          data.push([$translate.instant('projectsIw.segmentRate.loyalSessionRate'), vm.total.iw_use.loyal_session_rate]);
        }
        chart.resetSeries();
        chart.addSeries({ data });
      });
  }
}



// WEBPACK FOOTER //
// ../enterprise/src/zenclerk_modules/projects.iw/iw_segment_rate.js